export const findUserRole = (userRoles, roles) => {
  const userRole = userRoles.find((role) => roles.includes(role));
  return userRole ? userRole : '';
}

export const isUserInRole = (userRoles, role) => {
  return userRoles.includes(role);
}

export const isUserAdmin = (userRoles) => {
  return isUserInRole(userRoles, 'administrador');
}

export const isUserBoss = (userRoles) => {
  return isUserInRole(userRoles, 'jefe');
}

export const isUserEmployee = (userRoles) => {
  return isUserInRole(userRoles, 'empleado');
}